<h5>{{ anfrageTitel }}</h5>
<div class="app-chat-wrapper">
    <app-chat [anfrageId]="anfrageId" [scope]="scope"></app-chat>
</div>